import { render, staticRenderFns } from "./GiftCardEditor.vue?vue&type=template&id=dc35dce0&"
import script from "./GiftCardEditor.vue?vue&type=script&lang=js&"
export * from "./GiftCardEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports